import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptWallet} from "./wallet.adapter";
import type {Wallet, WalletApiResponse} from "./wallet.types";

export const getWalletService = async (): Promise<Wallet> => {
  const response = await httpRequest<WalletApiResponse>({
    method: "GET",
    url: "/user/wallet",
    baseUrl: config.walletApiUrl,
  });
  return adaptWallet(response);
};
